import { Button } from '@cambridgeassessment/cambridge-ui';
import React from 'react';

type Props = {
  onClick: () => void;
  className?: string;
};

const MakePrimary: React.FC<Props> = ({ onClick, className }) => {
  return (
    <Button
      className={className}
      data-testid="makePrimary"
      variant="text"
      size="small"
      onClick={onClick}
    >
      Make primary
    </Button>
  );
};

export default MakePrimary;
